import { Toggle, Tooltip } from "@mixitone/components";
import type { Club, ClubPermission, PermissionKey } from "@mixitone/models";
import { AccountUser } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import { useCallback } from "react";

const PermissionToggle = ApplicationView(
  ({
    disabled,
    overrideChecked,
    permission,
    perm,
  }: {
    disabled: boolean;
    overrideChecked?: boolean;
    permission: ClubPermission;
    perm: PermissionKey;
  }) => {
    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
      permission[perm] = e.target.checked;
    }, []);

    return (
      <td>
        <div className="flex items-center justify-center">
          <Toggle
            disabled={disabled}
            small
            checked={overrideChecked || (permission[perm] ?? false)}
            onChange={handleChange}
          />
        </div>
      </td>
    );
  },
);

interface Props {
  accountUser?: AccountUser;
  club: Club;
  permission: ClubPermission;
  permissionKeys: PermissionKey[];
}

const ClubPermissionRow: React.FC<Props> = ({ accountUser, club, permission, permissionKeys }) => {
  const isAccountAdmin = accountUser?.isAdmin();
  const isClubAdmin = AccountUser.current?.clubPermissionFor(club.id!)?.admin_club;
  const disabled = isAccountAdmin || !isClubAdmin;
  const overrideChecked = isAccountAdmin ? true : undefined;

  return (
    <tr key={club.domKey()} className="*:px-1 *:py-1 even:bg-slate-50">
      <td>{club.name}</td>
      <td>
        {!isClubAdmin && <Tooltip icon>You do not have admin access to change these permissions</Tooltip>}
      </td>
      {permissionKeys.map((perm) => (
        <PermissionToggle
          key={perm}
          disabled={disabled}
          overrideChecked={overrideChecked}
          permission={permission}
          perm={perm}
        />
      ))}
    </tr>
  );
};

export default ApplicationView(ClubPermissionRow);
